<template>
  <el-dialog :visible.sync="show" :title="$t('m.sign_record')" :close-on-click-modal="false" :append-to-body="true" :close="resetForm">
    <!-- <el-form size="small" :model="model" label-position="left" :inline="true" ref="theForm">
      <el-form-item prop="contractStatus" :label="$t('m.current_contract_status')+':'">
        <span v-if="model.contractStatus ===0">{{$t('m.subscription_closed')}}</span>
        <span v-if="model.contractStatus ===1">{{$t('m.sign_ing')}}</span>
      </el-form-item>
    </el-form> -->
    <div class="p">
      {{ $t('m.current_contract_status') }} : 
      <span v-if="model.contractStatus ===0">{{$t('m.subscription_closed')}}</span>
      <span v-if="model.contractStatus ===1">{{$t('m.sign_ing')}}</span>
    </div>
    <div class="overline">
      <el-table :data="tableData" border style="width: 100%" v-loading="loading.table" :element-loading-text="''" element-loading-spinner="el-icon-loading">
        <el-table-column prop="signDt" :label="$t('m.sign_time')"></el-table-column>
        <el-table-column prop="cancelDt" :label="$t('m.release_time')"></el-table-column>
        <el-table-column prop="contractStatus" :label="$t('m.sign_status')">
          <template slot-scope="scope">
            <span v-if="scope.row.contractStatus ===0">{{$t('m.subscription_closed')}}</span>
            <span v-if="scope.row.contractStatus ===1">{{$t('m.sign_ing')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="undoReason" :label="$t('m.termination_reason')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="applyTime" :label="$t('m.apply_time')"></el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import { getAnchorContractLog } from '../../../api/approval/anchor-approval';

export default {
  name: 'user-freeze-dialog',
  data() {
    return {
      btnLoading: false,
      types: [],
      tableData: [],
      pager: {
        page: 1,
        limit: 10,
        total: 0
      },
      show: false,
      loading: {
        table: false,
        form: false
      },
      model: {
        contractStatus: null,
        userId: null,
        guildId: null,
      },
    };
  },
  methods: {
    showDialog(row) {
      this.model.userId = row.userId;
      this.model.guildId = row.guildId;
      // this.model.contractStatus = row.contractStatus;
      this.getTableData();
      this.show = true;
    },
    // 获取签约记录列表
    getTableData() {
      this.loading.table = true;
      getAnchorContractLog({
          query: this.model,
          pager: this.pager,
          sorter: this.sorter
      })
        .then(({ data }) => {
          this.tableData = data.data.list;
          if(this.tableData.length>0) {
            this.model.contractStatus = this.tableData[0].contractStatus;
          }
          this.loading.table = false;
        })
        .catch(error => {
          this.loading.table = false;
        });
    },
    resetForm() {
      this.$refs.createForm.resetFields();
      this.btnLoading = false;
    }
  }
};
</script>
<style scoped>
.p{
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/anchor/dialogs/anchorCooperationLogDialog.vue